import { useTranslation } from "react-i18next";

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-gradient-to-b from-background-800 to-background-950 relative overflow-hidden">
      <div className="px-4 md:px-6 py-16 md:py-24">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100/15 text-accent-200 text-xs font-medium mb-5 whitespace-nowrap">
          Kakobuy Sheet
        </span>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-white max-w-2xl leading-tight">
          {t("trust.title")}
        </h2>

        <p className="mt-4 text-foreground-200/70 text-sm md:text-base leading-relaxed max-w-xl">
          {t("trust.description")}
        </p>

        <div className="flex flex-col lg:flex-row gap-10 md:gap-14 mt-12">
          <div className="lg:w-1/2">
            <div className="w-full aspect-square max-w-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Fashion%20accessories%20and%20sneakers%20flatlay%20on%20warm%20cream%20minimal%20background%2C%20clean%20editorial%20product%20photography%2C%20soft%20natural%20light%20from%20left%2C%20elegant%20composition%20with%20negative%20space%2C%20light%20beige%20and%20cream%20tones%2C%20professional%20catalog%20aesthetic%2C%20subtle%20organic%20textures%2C%20high%20end%20product%20display&width=800&height=800&seq=trust-product-2026&orientation=squarish"
                alt="Kakobuy produkty"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col justify-center">
            <p className="font-heading text-6xl md:text-8xl font-bold text-white leading-none">
              {t("trust.stats.number")}
            </p>
            <p className="mt-3 text-foreground-200/60 text-sm md:text-base max-w-sm leading-relaxed">
              {t("trust.stats.label")}
            </p>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-background-50 text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer self-start"
            >
              {t("trust.cta")}
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}